import { render, staticRenderFns } from "./CardReceiveOptionForm.vue?vue&type=template&id=2a030c66&scoped=true"
import script from "./CardReceiveOptionForm.vue?vue&type=script&lang=js"
export * from "./CardReceiveOptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a030c66",
  null
  
)

export default component.exports